import React, { useState, useEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import "./Leftbar.scss";

// Icons
import Dashicon from "../Component/NewUiimg/house-outline.png";
import STUDENTLIST from "../Component/NewUiimg/list.png";
import infirmaryicon from "./NewUiimg/doctor-stethoscope.png";
import uploadicon from "./NewUiimg/upload.png";
import reports from "../Component/NewUiimg/reports.png";
import Growth from "./NewUiimg/Growth.png";
import physical from "./NewUiimg/physical.png";
import eye from "./NewUiimg/eye.png";
import ent from "./NewUiimg/ent.png";
import tooth from "./NewUiimg/tooth.png";
import clinic from "./NewUiimg/smartclinic.png";

const Leftbar = (props) => {
  const { dim, history, location, currentProgram, startNodeMap } = props;
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    setActiveSection(history.location.pathname);
    const unlisten = history.listen((loc) => setActiveSection(loc.pathname));
    return () => unlisten();
  }, [history]);

  if (!dim || dim.width < 768) return null;

  // 🧠 Sidebar navigation items
  const sidebarItems = [
    { label: "DASHBOARD", route: "/dashboard", icon: Dashicon },
    // { label: "STUDENT LIST", route: "/student", icon: STUDENTLIST },
    {
      label: "REPORTS",
      route: "/care-assessment",
      icon: STUDENTLIST,
    },
    { label: "INFIRMARY", route: "/infirmary", icon: infirmaryicon },
    { label: "UPLOAD", route: "/upload", icon: uploadicon },
  ];

  const assessmentMap = {
    growth: { name: "Growth Assessment", image: Growth },
    physical: { name: "Physical Assessment", image: physical },
    ent: { name: "ENT Assessment", image: ent },
    eye: { name: "Eye Assessment", image: eye },
    dental: { name: "Dental Assessment", image: tooth },
  };

  const hiddenPaths = [
    "/student-profile",
    "/student",
    "/care-assessment",
    "/infirmary",
    "/upload",
  ];
  const isHiddenPath = hiddenPaths.includes(location.pathname);

  const handleOptionClick = (route) => {
    // if (route === "/student") {
    if (route === "/care-assessment") {
      sessionStorage.removeItem("studentListState");
    }

    history.push(route);
    setActiveSection(route);
  };

  const handleReportChange = (type) => {
    const startNode = currentProgram.billing
      ? startNodeMap[currentProgram.billing.id]
      : null;
    if (startNode)
      window.open(`/report/school/${startNode.id}/${type}`, "_blank");
  };

  const getPWBHSGMarginTop = () => {
    switch (location.pathname) {
      // case "/student":
      case "/care-assessment":
      case "/infirmary":
      case "/upload":
      case "/student-profile":
        return "330px";
      case "/dashboard":
        return "78px";
      default:
        return "";
    }
  };

  // 🧩 Helper to render a sidebar item
  const SidebarItem = ({ route, icon, label }) => (
    <div
      key={route}
      onClick={() => handleOptionClick(route)}
      style={{
        padding: "15px 20px",
        position: "relative",
        cursor: "pointer",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "2em",
      }}
    >
      <img className="dashiconV2" src={icon} alt={`${label} Icon`} />
      <p
        className="dashclass"
        style={{
          fontFamily: "Montserrat",

          fontWeight: activeSection === route ? 500 : "normal",
        }}
      >
        {label}
      </p>

      {activeSection == route && (
        <div
          style={{
            height: "80%",
            width: "2px",
            position: "absolute",
            right: 0,
            top: "10%",
            backgroundColor: "#1e87f0",
          }}
        />
      )}
    </div>
  );

  return (
    <div className="mysidepanel">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: "2em",
        }}
      >
        {sidebarItems?.map(({ route, label, icon }) => (
          <SidebarItem key={route} route={route} label={label} icon={icon} />
        ))}
      </div>

      <div style={{ paddingLeft: "20px" }}>
        <hr className="horizontalsidepanel" />
      </div>

      {/* Reports Section */}
      {!isHiddenPath && (
        <>
          <div
            className="sidebar-item"
            style={{
              padding: "15px 20px",
              position: "relative",
              cursor: "pointer",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "2em",
            }}
          >
            <img className="dashiconV2" src={reports} alt="Reports Icon" />
            <p
              className="dashclass"
              style={{
                fontSize: 12,
                fontFamily: "Montserrat",
                fontWeight: "400",
                paddingTop: "10px",
              }}
            >
              REPORTS
            </p>
          </div>

          {/* <div style={{ paddingLeft: "20px" }}>
            {Object.entries(assessmentMap).map(([type, { name, image }]) => (
              <div
                key={type}
                style={{ paddingTop: 0 }}
                className="sidebar-item"
                onClick={() => handleReportChange(type)}
              >
                <img
                  className="reportsiconV2"
                  src={image}
                  alt={`${name} Icon`}
                />

                <p
                  style={{
                    fontSize: 11,
                    fontFamily: "Montserrat",
                    fontWeight: "400",
                    paddingTop: "10px",
                  }}
                >
                  {name}
                </p>
              </div>
            ))}
          </div> */}
        </>
      )}

      {/* Footer */}
      <div style={{ flex: 1, display: "flex", alignItems: "end" }}>
        <p
          className="PWBHSGTXT"
          style={{ lineHeight: "20px", padding: "15px 20px" }}
        >
          Powered by HealthSetGo
          <br />
          All rights reserved
        </p>
      </div>
    </div>
  );
};

// Redux connections
const mapStateToProps = (state) => ({
  currentProgram: state.organization.currentProgram,
  startNodeMap: state.organization.startNodeMap,
});

export default withRouter(connect(mapStateToProps)(Leftbar));
